import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faFile,
  faFileAudio,
  faFileCode,
  faFileExcel,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFileZipper,
} from '@fortawesome/free-regular-svg-icons';

const iconByExtension: Record<string, IconDefinition> = {
  xlsx: faFileExcel,
  xls: faFileExcel,
  csv: faFileExcel,
  tsv: faFileExcel,
  docx: faFileWord,
  doc: faFileWord,
  pptx: faFilePowerpoint,
  ppt: faFilePowerpoint,
  pdf: faFilePdf,
  md: faFileLines,
  txt: faFileLines,
  zip: faFileZipper,
  json: faFileCode,
  yaml: faFileCode,
  yml: faFileCode,
  js: faFileCode,
  ts: faFileCode,
  mp3: faFileAudio,
  wav: faFileAudio,
  m4a: faFileAudio,
  mp4: faFileVideo,
  mov: faFileVideo,
  webm: faFileVideo,
};

export const fileExtensionIcon = (filename: string): IconDefinition => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex < 0) return faFile;

  return iconByExtension[filename.slice(dotIndex + 1).toLowerCase()] ?? faFile;
};
